import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query generatePassword {
  generatePassword
}`;

function generatePassword() {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
  })
    .then((res) => res.data.generatePassword)
    .catch((err) => {
      if (err.graphQLErrors.length) {
        throw err.graphQLErrors[0].error.code;
      } else {
        throw err;
      }
    });
}

export default generatePassword;
